import ScalarTextInput_default from "./ScalarTextInput.vue.js";
import ScalarTextInputCopy_default from "./ScalarTextInputCopy.vue.js";
export { ScalarTextInput_default as ScalarTextInput, ScalarTextInputCopy_default as ScalarTextInputCopy };
